"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spec = exports.NAMESPACE = void 0;
const platform_1 = require("@effect/platform");
const effect_1 = require("effect");
const Device = __importStar(require("../../../../../../device"));
const openapi_1 = require("../../../../../openapi");
const Common = __importStar(require("../../common"));
const Telemetry = __importStar(require("./schema"));
exports.NAMESPACE = 'Culligan.Api.V2.Spec.Legacy.Fleet.Telemetry.Spec';
/*
 * `routes/v2/api/fleet/telemetry/router.js`: `GET /v2/fleet/telemetry/history`
 * with `[read, satCredentialRouteGuard]`, controller on protocol v1.
 */
// Query struct intentionally has no identifier. Effect only emits query
// parameters when the top-level JSON Schema exposes `properties` inline.
const HistoryQuery = effect_1.Schema.Struct({
    model: effect_1.Schema.propertySignature(Device.Class.Common.ModelCode).annotations({
        description: 'Model of the device; selects the telemetry schema',
    }),
    keys: effect_1.Schema.propertySignature(effect_1.Schema.Array(Telemetry.Key)).annotations({
        description: 'Telemetry keys to return; every key must belong to the model telemetry. ' +
            Common.ARRAY_QUERY_FORM('keys', 'uvc_stat', 'ht_temp'),
    }),
    deviceId: Device.Class.Common.Id,
    dateRangeStart: effect_1.Schema.propertySignature(effect_1.Schema.NumberFromString).annotations({
        description: 'Range start, Unix ms',
    }),
    dateRangeEnd: effect_1.Schema.propertySignature(effect_1.Schema.NumberFromString).annotations({
        description: 'Range end, Unix ms. Must exceed dateRangeStart.',
    }),
});
const history = platform_1.HttpApiEndpoint.get('getTelemetryHistory') `/history`
    .setUrlParams(HistoryQuery)
    .addSuccess(openapi_1.Response.Success(Telemetry.History).annotations({
    description: 'Telemetry samples of the requested keys',
}))
    .addError(Telemetry.RequestValidation)
    .addError(Telemetry.ResponseValidation)
    .addError(openapi_1.Error.V1NotAuthorized)
    .annotate(platform_1.OpenApi.Title, 'Device Telemetry History')
    .annotate(platform_1.OpenApi.Description, 'Returns the telemetry samples of one device in the range, restricted to the requested keys. ' +
    'The request is decoded against the telemetry schema of `model`, so unknown keys answer 400 `INVALID_REQUEST`. ' +
    'Answers 401 when a SAT does not grant `deviceId`, 422 when the stored samples do not decode.')
    .pipe(Common.withReadOrSatGuard, openapi_1.Error.withV1StandardErrors);
exports.Spec = platform_1.HttpApiGroup.make('v2.fleet.telemetry')
    .add(history)
    .prefix('/fleet/telemetry')
    .annotate(platform_1.OpenApi.Title, 'Fleet Telemetry')
    .annotate(platform_1.OpenApi.Description, 'Telemetry history of one device')
    .pipe(openapi_1.Audience.withAudiences(openapi_1.Audience.Audience.Fleet));
//# sourceMappingURL=spec.js.map